{
  "check-details": "Виж детайли →",
  "no-result-found": "Няма намерени продукти в тази категория.",
  "technical-characteristics": "Технически характеристики",
  "Please fill out this field.": "Моля, попълнете това поле."
}
